import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { cn } from '../../../../utils';
import CustomPopover from '../../Common/CustomPopover';
import RedDot from '../../Common/RedDot';
import Notifications from '../Notifications';

const MdNotificationsNone = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdNotificationsNone)
);

export default function NotificationMenu() {
  const router = useRouter();
  const isNotificationsPage = router.pathname === '/notifications';
  // const unreadNotifications = useSelector(
  //   ({ notifications }) => notifications?.unreadNotifications
  // );

  const unreadCount = useSelector(
    ({ notifications }) => notifications?.unreadCount
  );

  return (
    <CustomPopover
      triggerComponent={
        <div className='relative h-[24px] w-[24px]'>
          <MdNotificationsNone
            className={cn(
              'text-[24px]',
              !isNotificationsPage ? 'cursor-pointer' : 'cursor-text'
            )}
          />
          {unreadCount > 0 && <RedDot />}
        </div>
      }
    >
      {!isNotificationsPage && <Notifications />}
    </CustomPopover>
  );
}
